import * as graphql from '@treams/treams-network';
import { SidebarLayout } from '@treams/treams-ui';

import { FeedbackResults, FeedbackResultsSkeleton } from './FeedbackResults';
import { FeedbackResultsSidebar, FeedbackResultsSidebarSkeleton } from './FeedbackResultsSidebar';

export function FeedbackResultsLayout(props: { request: graphql.FeedbackRequest }) {
	return (
		<SidebarLayout fill right sidebar={<FeedbackResultsSidebar request={props.request} />}>
			<FeedbackResults request={props.request} />
		</SidebarLayout>
	);
}

export function FeedbackResultsLayoutSkeleton() {
	return (
		<SidebarLayout fill right sidebar={<FeedbackResultsSidebarSkeleton />}>
			<FeedbackResultsSkeleton />
		</SidebarLayout>
	);
}
